import to_array from "./to_array"

export default function first(any) {
    return to_array(any)[0]
}
